import http from "../http-common";

const Get = (url, id) => {
  if (id === undefined) {
    return http.get(url);
  } else {
    return http.get(url + "/" + id);
  }
};

const Post = (url, data) => {
  return http.post(url, data);
};


export default {
  Get,
  Post,

};
